import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@quadminds/mindkit';
import { FC, PropsWithChildren } from 'react';

interface YpfIntegrationModalBase {
    isOpen: boolean;
    handleCloseModal: (value: boolean) => void;
    title: string;
}

const YpfIntegrationModalBase: FC<PropsWithChildren<YpfIntegrationModalBase>> = ({
    isOpen,
    handleCloseModal,
    title,
    children,
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={handleCloseModal}>
            <DialogContent className="max-w-[784px] w-full gap-0">
                <DialogHeader className="mb-3">
                    <DialogTitle>{title}</DialogTitle>
                </DialogHeader>
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default YpfIntegrationModalBase;
